export const LIST_MENU = 'list/menu'
